export class LaboratoryExaminationCertificateDto {
    laboratoryExaminationCertificateId: number;
    name: string;
    verdict: string;
    remark: string;
    attachmentId: number;
    requestId: number;
    activityId: number;
    useAccreditationNote: boolean;
    signingUserId: number;
    indicatorsRemarkDescription: string;

    correctionReason: string;
}